import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { AcademicYearApi } from "../../../api/academic-year/academic-year.api";
import { dateToView } from "../../../utils/date.utils";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");
    const [id_academic_year, set_id_academic_year] = useState<string>("");


    const [data, setData] = useState<any[]>([{}]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<any>({})
    const [showModal, setShowModal] = useState<string>("");

    const handleCloseModal = () => {
        setShowModal("");
        // set_id_gallery_type(null);
        set_form(null)
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'center', label: t("MANAGE_ACADEMIC_YEAR")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("MANAGE_ACADEMIC_YEAR_START_DATE")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("MANAGE_ACADEMIC_YEAR_END_DATE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("MANAGE_ACADEMIC_YEAR_STATUS")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("MANAGE_ACADEMIC_YEAR_LAST_UPDATED_BY")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("MANAGE_ACADEMIC_YEAR_LAST_UPDATED_DATE")
        },

        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 180, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            academic_year_start,
            created_by,
            created_date,
            modified_date,
            academic_year,
            id_academic_year,
            academic_year_end,
            modified_by,
            status
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: academic_year || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: dateToView(academic_year_start) || "-",
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: dateToView(academic_year_end) || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <SwitchCustom
                        // disabled={!checkPermit.isUpdate}
                        checked={status === 'active'} onChange={(st) => handleChangeStatus(id_academic_year, st ? "active" : "inactive")} />,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                setShowModal('VIEW');
                                // set_form(objData)
                                set_id_academic_year(id_academic_year)
                                handleGetOneDetail(id_academic_year)
                            }}
                            onEditClick={() => {
                                setShowModal('EDIT');
                                // set_form(objData)
                                set_id_academic_year(id_academic_year)
                                handleGetOneDetail(id_academic_year)
                            }}
                            onDeleteClick={() => handleDeleteList(id_academic_year)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

        const handleChangeStatus = async (id_academic_year: number, status: string) => {
            await AcademicYearApi.updateAcademicYearStatus(id_academic_year, { status: status, }).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    const handleDeleteList = (id_academic_year: number) => {
        alertActive(t("MANAGE_ACADEMIC_YEAR_DELETE"), t("MANAGE_ACADEMIC_YEAR_CONFIRM_DELETE"), undefined, undefined, async () => {
            dispatch(setLoading());
            await AcademicYearApi.deleteAcademicYear(id_academic_year).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("MANAGE_ACADEMIC_YEAR_DELETE"), t("MANAGE_ACADEMIC_YEAR_DELETE_COMPLETED"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("MANAGE_ACADEMIC_YEAR_DELETE"), t("MANAGE_ACADEMIC_YEAR_DELETE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await AcademicYearApi.getAcademicYearList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    const handleGetOneDetail = async (id_academic_year: number) => {
        dispatch(setLoading());
        await AcademicYearApi.getAcademicYearById(id_academic_year).then((res) => {
            if (res.status < 300) {
                set_form(res.data.data)
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleSubmit = async () => {
        dispatch(setLoading());
        if (id_academic_year) {
            await AcademicYearApi.updateAcademicYear(+id_academic_year, form).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("MANAGE_ACADEMIC_YEAR_EDIT"), t('MANAGE_ACADEMIC_YEAR_EDIT_COMPLETED'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("MANAGE_ACADEMIC_YEAR_EDIT"), t("MANAGE_ACADEMIC_YEAR_EDIT_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await AcademicYearApi.createAcademicYear(form).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("MANAGE_ACADEMIC_YEAR_CREATE"), t("MANAGE_ACADEMIC_YEAR_CREATE_COMPLETED"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("MANAGE_ACADEMIC_YEAR_CREATE"), t("MANAGE_ACADEMIC_YEAR_CREATE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        showModal,
        handleCloseModal,
        form,
        set_form,
        setShowModal,
        handleSubmit
    }
}

export default ManageState